import { Swiper } from 'mondrian-react'

import useWindowSize from 'hooks/useWindowSize'
import { logger } from 'utils/logger'

import './style.scss'
import "swiper"
import { reportGA4 } from 'utils/pushDataLayer'

export default function CarouselBanners() {
  const size = useWindowSize();
  const MOBILE_WIDTH = 767;

  let banners = {
    "data": {
      "Campanha": [
        {
          "codCampanha": "IPHONE15UAUFORIA",
          "descricao": "iphone15_uauforia_carrossel",
          "url": "https://planoscelular.claro.com.br/c/smartphone?q=:relevance:allCategories:IPHONE&utm_source=minhaclaro-areanaologada&utm_medium=banner_site&utm_campaign=ap_areanaologada_banner_site_p1&utm_id=redirectfaturafacil",
          "ativo": true,
          "urlImg": "/banners/images/banner-iphone-15-lancamento-29-09-MCM-desktop.png",
          "urlImgMobile": "/banners/images/banner-iphone-15-lancamento-29-09-MCM-mobile.png",
          "textoPrincipal": "",
          "nameTag": "iphone15_uauforia"
        },
        {
          "codCampanha": "FATURADIGITAL",
          "descricao": "fatura_digital_carrossel",
          "url": "https://minhaclaro.claro.com.br/?redirect-feature=FaturasCadastroFaturaDigital&utm_source=incentivomsmsite&utm_medium=RedirectFaturaFacilparamcmsite&utm_id=redirectfaturafacil",
          "ativo": true,
          "urlImg": "/banners/images/banner-fatura-desktop.png",
          "urlImgMobile": "/banners/images/banner-fatura-mobile.png",
          "textoPrincipal": "",
          "nameTag": "fatura_digital"
        },
        {
          "codCampanha": "SUPORTETECNICO",
          "descricao": "suporte_tecnico_carrossel",
          "url": "https://minhaclaro.claro.com.br/?redirect-feature=AtendimentoGuiaSolucoes&utm_source=incentivomsmsite&utm_medium=RedirectFaturaFacilparamcmsite&utm_id=redirectfaturafacil",
          "ativo": true,
          "urlImg": "/banners/images/banner-suporte-desktop.png",
          "urlImgMobile": "/banners/images/banner-suporte-mobile.png",
          "textoPrincipal": "",
          "nameTag": "suporte_tecnico"
        },
        {
          "codCampanha": "LOJAONLINE",
          "descricao": "loja_online_carrossel",
          "url": "https://minhaclaro.claro.com.br/?redirect-feature=Loja&utm_source=incentivomsmsite&utm_medium=RedirectFaturaFacilparamcmsite&utm_id=redirectfaturafacil",
          "ativo": true,
          "urlImg": "/banners/images/banner-loja-desktop.png",
          "urlImgMobile": "/banners/images/banner-loja-mobile.png",
          "textoPrincipal": "",
          "nameTag": "loja_online"
        },
        {
          "codCampanha": "CLAROCLUBE",
          "descricao": "claro_clube_carrossel",
          "url": "https://minhaclaro.claro.com.br/?redirect-feature=ClaroClubeClienteCadastrado&utm_source=incentivomsmsite&utm_medium=RedirectFaturaFacilparamcmsite&utm_id=redirectfaturafacil",
          "ativo": true,
          "urlImg": "/banners/images/banner-claroclube-desktop.png",
          "urlImgMobile": "/banners/images/banner-claroclube-mobile.png",
          "textoPrincipal": "",
          "nameTag": "claro_clube"
        }
      ]
    }
  }

  return (
    <div className="banners-swiper-container">
      <Swiper
        bullets={true}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true}}
      >
        {banners.data.Campanha.map((banner, index) =>
          <div className='banner-container' key={`banner-${index}`}>
            <a href={banner.url} target="_blank" rel="noreferrer" 
              onClick={() => {
                logger({ name: "Banners", element: banner.descricao })
                reportGA4({customTitle: `banner:${banner.nameTag}`})
              }}>
              <img
                src={size.width <= MOBILE_WIDTH ? banner.urlImgMobile : banner.urlImg}
                alt={banner.descricao}
              />
            </a>
          </div>
        )}
      </Swiper >
    </div >
  )
}